import { Card } from '../../../services/table/tableTypes';

export const checkWinningCard = (card: Card, winningCards: Card[]): boolean => {
  return winningCards.some((winningHand: Card) => winningHand.rank === card.rank && winningHand.suit === card.suit);
};
